<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-sidebar></app-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i
          class="material-icons"
          id="menu-toggle"
          @click="isSidebar = !isSidebar"
          >view_headline</i
        >
        <app-navbar></app-navbar>
        <div class="container-fluid mt-5" id="grad1">
          <!-- breadcrumb and title row starts -->
          <div class="row">
            <div class="col-sm-12 print-scr">
              <vs-breadcrumb
                align="left"
                :items="[
                  { title: 'You are here : ' },
                  {
                    title: 'Dashboard',
                    url: '/#/dashboard/program-officer/todoList'
                  },

                  {
                    title: 'Training Wizard',
                   
                  },
                  {
                    title: ` ${trainingTitle}`,
                    active: true,
                    class: 'font-bold'
                  }
                ]"
              ></vs-breadcrumb>
            </div>
            <div class="col-sm-12">
              <div class="heading mt-3">
                <h3 class="text-secondary">Training Wizard</h3>
              </div>
            </div>
          </div>
          <!-- breadcrumb and title row Ends -->
          <div class="row justify-content-center mt-0">
            <div class="col-11 text-center p-0 mt-3 mb-2">
              <div class="card px-0 pb-0 mt-3 mb-3">
                <div class="row">
                  <div class="col-md-12 mx-0">
                    <form id="msform">
                      <!-- progressbar -->
                      <ul id="progressbar">
                        <li
                          title="Warning! You are not authorized to access."
                          id="NewTraining"
                        >
                          <strong>Training Assignment</strong>
                        </li>
                        <li
                          title="Warning! You are not authorized to access."
                          id="PoAssignment"
                        >
                          <strong>P.O Assignment</strong>
                        </li>
                        <li
                          @click="trainingInformation()"
                          class="completed"
                          id="TrainingInformation"
                        >
                          <strong>Event Information</strong>
                        </li>
                        <li
                          @click="trainerRegistration()"
                          class="completed"
                          id="TrainerRegistration"
                        >
                          <strong>Facilitators' Registration</strong>
                        </li>
                        <li
                          @click="trainingAgenda()"
                          class="completed"
                          id="TrainingAgenda"
                        >
                          <strong>Training Agenda</strong>
                        </li>
                        <li
                          @click="trainingMaterial()"
                          class="completed"
                          id="Trainingmaterial"
                        >
                          <strong>Upload Material</strong>
                        </li>
                        <li
                          @click="trainingAssessment()"
                          class="completed"
                          id="TrainingAssessments"
                        >
                          <strong>Assessments</strong>
                        </li>

                        <li
                          @click="traineeReg()"
                          class="completed"
                          id="TraineeRegistration"
                        >
                          <strong>Participants' Registration</strong>
                        </li>
                        <li
                          @click="assessmentReviewFunction()"
                          class="completed"
                          id="AssessmentReview"
                        >
                          <strong>Assessment Review</strong>
                        </li>
                        <li class="active" id="Completion">
                          <strong>Completion</strong>
                        </li>
                      </ul>
                      <!-- fieldsets -->
                      <fieldset
                        style="text-align: left;padding: 30px; min-height: 300px"
                      >
                        <span
                          v-if="this.training_status.preassesment_status == 1 && this.training_status.postassesment_status == 1"
                        >
                          <h5 class="text-center text-success mt-5">
                            <i class="material-icons">check</i> This Training
                            has been setup successfully!
                          </h5>
                        </span>
                        <span class="mt-3" v-else>
                          <h5 class="text-center text-danger">
                            Warning! This Training is not completed and still
                            In-Progress
                          </h5>
                          <hr />
                          <li
                            class="text-success"
                            v-if="this.training_status.preassesment_status == 1"
                          >
                            <i class="material-icons">check</i> Pre Assessment
                            is enabled and being completed.
                          </li>
                          <li v-else class="text-danger">
                            <i class="material-icons">close</i> Pre Assessment
                            is not enabled yet.
                          </li>
                          <li
                            class="text-success"
                            v-if="this.training_status.postassesment_status == 1"
                          >
                            <i class="material-icons">check</i> Post Assessment
                            is enabled and being completed.
                          </li>
                          <li v-else class="text-danger">
                            <i class="material-icons">close</i> Post Assessment
                            is not enabled yet.
                          </li>
                          <li
                            class="text-success"
                            v-if="this.training_status.feedbackstatus == 1"
                          >
                            <i class="material-icons">check</i> Feedback is
                            enabled and being completed.
                          </li>
                          <li v-else class="text-danger">
                            <i class="material-icons">close</i> Feedback is not
                            enabled yet.
                          </li>
                          <hr />
                        </span>

                        <!-- row 1 starts  -->
                        <div
                          class="row mt-3 mb-4 d-flex justify-content-center"
                        >
                          <button class="btn btn-primary float-right ml-3">
                            <router-link
                              :to="{
                              path:
                                '/dashboard/programOfficer/brief_training_report',
                              query: { trainingId: this.trainingCode }
                            }"
                              class="white-text"
                              >Brief Training Details
                            </router-link>
                          </button>

                          <button class="btn btn-primary float-right ml-3">
                            <router-link
                              :to="{
                                path:
                                  '/dashboard/programOfficer/analysis-report',
                                query: { trainingId: this.trainingCode }
                              }"
                              class="white-text"
                              >Overall Training Analysis</router-link
                            >
                          </button>

                          <button class="btn btn-primary float-right ml-3">
                            <router-link
                              :to="{
                                path:
                                  '/dashboard/programOfficer/individual_analysis_report',
                                query: { trainingId: this.trainingCode }
                              }"
                              class="white-text"
                              >Individual Training Analysis</router-link
                            >
                          </button>
                          <button
                            class=" btn btn-primary float-right ml-3"
                            @click="getReport"
                          >
                            Download Training Report
                          </button>
                        </div>
                        <!-- row 1 ends -->
                        <!-- Review and Edit -->
                        <div class="row d-flex justify-content-center">
                          <button class="btn btn-info">
                            <router-link
                              :to="{ path:'/dashboard/programOfficer/training-Information',query: { trainingId: this.trainingCode }}"
                              class="white-text"
                              >Review & Edit
                              <i class="material-icons" style="font-size: 20px;"
                                >edit</i
                              ></router-link
                            >
                          </button>
                          <button
                            class="btn btn-info float-right ml-5"
                            @click="printSheet"
                          >
                            Attendance Sheet
                            <i class="material-icons" style="font-size: 20px;"
                              >people</i
                            >
                          </button>
                        </div>
                      </fieldset>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <template>
            <div>
              <div id="attendance-sheet">
                <div class="header">
                  <img
                    :src="basepath+'/unodc_logo.png'"
                    alt="UNODC Logo"
                    :style="{ width: '200px' }"
                  />
                  <h2>Training Attendance Sheet</h2>
                </div>

                <p class="address">
                  G-5, Islamabad, Phone: (051) 2601461 <br />UNODC COAPK, Plot#
                  5, Diplomatic Enclave
                </p>

                <table>
                  <tr>
                    <th colspan="4" style="text-align: left;">
                      Training Title: {{attendanceData.trainingResponse.title}}
                    </th>
                    <th colspan="3" style="text-align: left;">
                      Training Dates:
                      {{formattedDate(attendanceData.trainingResponse.startdate)}}
                      to
                      {{formattedDate(attendanceData.trainingResponse.enddate)}}
                    </th>
                  </tr>
                  <tr>
                    <th colspan="4" style="text-align: left;">
                      Event Venue: {{attendanceData.trainingResponse.venue}}
                    </th>
                    <th colspan="3" style="text-align: left;">
                      Total No. of Participants: (___________)
                    </th>
                  </tr>
                </table>
                <br />
                <table>
                  <tr>
                    <th colspan="5" class="list_name">Trainees</th>
                    <th :colspan="attendanceData.trainingResponse.noofdays">
                      Signature
                    </th>
                  </tr>
                  <tr>
                    <th>S#</th>
                    <th>Name</th>
                    <th>Organization</th>
                    <th>Designation</th>
                    <th>Mobile No</th>
                    <th
                      v-for="day in Number(attendanceData.trainingResponse.noofdays)"
                      :key="'day-' + day"
                    >
                      Day-{{ day }}
                    </th>
                  </tr>
                  <tr
                    v-for="(user, index) in attendanceData.traineeResponse"
                    :key="index"
                  >
                    <td>{{ index + 1 }}</td>
                    <td>{{ user.name ?? ' '}}</td>
                    <td>{{ user.department[0]?.title ?? ' '}}</td>
                    <td>{{user.designation[0]?.title ?? ' '}}</td>
                    <td>{{user.contactNo }}</td>
                    <td
                      v-for="day in Number(attendanceData.trainingResponse.noofdays)"
                      :key="'user-day-' + index + '-' + day"
                    ></td>
                  </tr>
                  <tr v-for="emptyIndex in 10" :key="'empty-' + emptyIndex">
                    <td>
                      {{ attendanceData.traineeResponse.length + emptyIndex }}
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td
                      v-for="day in Number(attendanceData.trainingResponse.noofdays)"
                      :key="'user-day-' + index + '-' + day"
                    ></td>
                  </tr>
                </table>
                <br />
                <table>
                  <tr>
                    <th colspan="5" class="list_name">UNODC Staff</th>
                    <th :colspan="attendanceData.trainingResponse.noofdays">
                      Signature
                    </th>
                  </tr>
                  <tr>
                    <th>S#</th>
                    <th>Name</th>
                    <th>Organization</th>
                    <th>Designation</th>
                    <th>Mobile No</th>
                    <th
                      v-for="day in Number(attendanceData.trainingResponse.noofdays)"
                      :key="'day-' + day"
                    >
                      Day-{{ day }}
                    </th>
                  </tr>
                  <tr
                    v-for="(user, index) in attendanceData.trainerResponse"
                    :key="index"
                  >
                    <td>{{ index + 1 }}</td>
                    <td>{{ user.trainer.name ?? ' '}}</td>
                    <td>{{ user.trainer.organization ?? ' '}}</td>
                    <td>{{user.trainer.designation ?? ' '}}</td>
                    <td>{{user.trainer.mobile ?? ' '}}</td>
                    <td
                      v-for="day in Number(attendanceData.trainingResponse.noofdays)"
                      :key="'user-day-' + index + '-' + day"
                    ></td>
                  </tr>
                  <tr v-for="emptyIndex in 2" :key="'empty-' + emptyIndex">
                    <td>
                      {{ attendanceData.trainerResponse.length + emptyIndex }}
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td
                      v-for="day in Number(attendanceData.trainingResponse.noofdays)"
                      :key="'user-day-' + index + '-' + day"
                    ></td>
                  </tr>
                </table>
                <br />
                <table>
                  <tr>
                    <th colspan="5" class="list_name">Supporting Staff</th>
                    <th :colspan="attendanceData?.trainingResponse?.noofdays">
                      Signature
                    </th>
                  </tr>
                  <tr>
                    <th>S#</th>
                    <th>Name</th>
                    <th>Organization</th>
                    <th>Designation</th>
                    <th>Mobile No</th>
                    <th
                      v-for="day in Number(attendanceData?.trainingResponse?.noofdays)"
                      :key="'day-' + day"
                    >
                      Day-{{ day }}
                    </th>
                  </tr>

                  <tr v-for="emptyIndex in 3" :key="'empty-' + emptyIndex">
                    <td>
                      {{ emptyIndex }}
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td
                      v-for="day in Number(attendanceData?.trainingResponse?.noofdays)"
                      :key="'empty-day-' + emptyIndex + '-' + day"
                    ></td>
                  </tr>
                </table>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import axios from "axios";
import {
    downloadTrainingReport
} from '../../../utils/DownloadReport';

export default {
    data: () => ({
        isSidebar: false,
        trainingCode: "",
        training_status: "",
        trainingTitle:"",
        basepath: localStorage.getItem("BASE_PATH"),
        attendanceData: [],
        designationArr:[],
    }),
    mounted() {
        axios.defaults.headers['Authorization'] = localStorage.getItem('token')
        this.trainingCode = this.$route.query.trainingId;
        this.openLoading();
        axios.get(localStorage.getItem("BASE_PATH") +
                "/programOfficer/trainingsingle/get/" +
                this.trainingCode

            )
            .then(response => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);

                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.closeLoading();
                this.trainingTitle = response.data.training.title;
                this.trainingId = response.data.training.id;
                this.training_status = response.data.training;
                if (response.data.training.trainingstatus == "In Queue") {
                    this.$router.push({
                        path: '/dashboard/programOfficer/training-information',
                        query: {
                            trainingId: this.trainingCode
                        }
                    });
                }
                this.getAttendance();

            });
             axios
      .get(localStorage.getItem("BASE_PATH") + "/designations/get")
      .then((response) => {
        this.designationArr = response.data;
      });
    },
    methods: {
       formattedDate(tdate) {
      const [year, month, day] = tdate.split("-");
      return `${day}-${month}-${year}`;
    },
     getDesignationTitle(designationId) {
        const match = this.designationArr?.find(
        (item) => item.id == designationId
      );
      return match ? match.title : '';
    },
        // onclick show wizard steps
        trainingInformation() {
            this.$router.push({
                path: '/dashboard/programOfficer/training-information',
                query: {
                    trainingId: this.trainingCode
                }
            });
        },
        trainerRegistration() {
            this.$router.push({
                path: '/dashboard/programOfficer/trainer-registration',
                query: {
                    trainingId: this.trainingCode
                }
            });
        },
        trainingAgenda() {
            this.$router.push({
                path: '/dashboard/programOfficer/training-agenda',
                query: {
                    trainingId: this.trainingCode
                }
            });
        },
        trainingMaterial() {
            this.$router.push({
                path: '/dashboard/programOfficer/wizardUploadMaterial',
                query: {
                    trainingId: this.trainingCode
                }
            });
        },
        trainingAssessment() {
            this.$router.push({
                path: '/dashboard/programOfficer/training-assesment',
                query: {
                    trainingId: this.trainingCode
                }
            });
        },
        traineeReg() {
            this.$router.push({
                path: '/dashboard/programOfficer/trainee-registration',
                query: {
                    trainingId: this.trainingCode
                }
            });
        },
        assessmentReviewFunction() {
            this.$router.push({
                path: '/dashboard/programOfficer/assesment-review',
                query: {
                    trainingId: this.trainingCode
                }
            });
        },
        getReport() {
            downloadTrainingReport(this.trainingCode)
        },
        openLoading() {
            this.$vs.loading({
                type: "material"
            });
        },
        closeLoading() {
            this.$vs.loading.close();
        },
        getAttendance() {
            this.openLoading();
            axios
                .get(
                    localStorage.getItem("BASE_PATH") + "/training/get-attendance/" + this.training_status.id
                )
                .then((response) => {
                    this.closeLoading();
                    this.attendanceData = response.data;

                });
        },

        printSheet: function () {
            const printContents = document.getElementById("attendance-sheet").innerHTML;
            const printWindow = window.open("", "_blank");

            printWindow.document.open();
            printWindow.document.write(`
                     <html>
    <head>
      <title>Print Sheet</title>
      <style>
        /* General styling */
        body { font-family: Arial, sans-serif; }

        /* Table styling */
        table {
          width: 100%;
          border-collapse: collapse;
        }
         td, tr {
          border: 1px solid black;
          padding: 8px;
          text-align: left;
        }
        th {
          background-color: #f2f2f2;
           border: 1px solid black;
          padding: 8px;
          text-align: center;
        }

        /* Header section styling */
        .header {
          justify-content: space-between;
          align-items: center;
        }
        h2 {
          text-align: center;
          text-decoration: underline;
        }

        /* Address section */
        .address {
          font-size: 14px;
          margin-top: 0px;
          text-align: left;
        }

        /* List name styling */
        .list_name {
          font-size: 18px;
        }
      </style>
    </head>
    <body onload="window.print()">
      ${printContents}
    </body>
  </html>

    `);
            printWindow.document.close();

        }
    },
    components: {
        "app-navbar": Navbar,
        "app-sidebar": Sidebar
    }
};
</script>

<style scoped>
.vs-breadcrumb {
  font-size: 18px !important;
  font-weight: 600 !important;
}
.btn-primary {
  font-size: 14px;
  height: 44px;
  background: #06a6e0;
  color: #ffffff;
  font-weight: 500;
  border-radius: 5px
}
.white-text {
  color: #ffffff;
}
.btn-primary:hover {
  background: #08769e;
}
.btn-secondary{
  height: 44px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 5px
}
.btn-info{
   height: 50px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 5px
}
#progressbar .completed {
  color: #06a6e0 !important;
}

#progressbar li.completed:before,
#progressbar li.completed:after {
  background: #06a6e0 !important;
}

#grad1 {
  background-color: #fff;
}

#msform {
  text-align: center;
  position: relative;
  margin-top: 20px;
}

#msform fieldset .form-card {
  background: white;
  border: 0 none;
  border-radius: 0px;
  box-shadow: 0 2px 2px 2px rgba(0, 0, 0, 0.2);
  padding: 20px 40px 30px 40px;
  box-sizing: border-box;
  width: 94%;
  margin: 0 3% 20px 3%;
  position: relative;
}

#msform fieldset {
  padding: 10px;
  background: #f7f7f7 !important;
  border: 0 none;
  border-radius: 2rem;
  box-sizing: border-box;
  width: 100%;
  margin: 0;
  border: 2px solid #ccc;
  padding-bottom: 20px;
  position: relative;
}

#msform fieldset:not(:first-of-type) {
  display: none;
}

#msform fieldset .form-card {
  text-align: left;
  color: #9e9e9e;
}

#msform .action-button {
  width: 100px;
  background: skyblue;
  font-weight: bold;
  color: white;
  border: 0 none;
  border-radius: 0px;
  cursor: pointer;
  padding: 10px 5px;
  margin: 10px 5px;
}

#msform .action-button:hover,
#msform .action-button:focus {
  box-shadow: 0 0 0 2px white, 0 0 0 3px skyblue;
}

#msform .action-button-previous {
  width: 100px;
  background: #616161;
  font-weight: bold;
  color: white;
  border: 0 none;
  border-radius: 0px;
  cursor: pointer;
  padding: 10px 5px;
  margin: 10px 5px;
}

#msform .action-button-previous:hover,
#msform .action-button-previous:focus {
  box-shadow: 0 0 0 2px white, 0 0 0 3px #616161;
}

select.list-dt {
  border: none;
  outline: 0;
  border-bottom: 1px solid #ccc;
  padding: 2px 5px 3px 5px;
  margin: 2px;
}

select.list-dt:focus {
  border-bottom: 2px solid skyblue;
}

.card {
  z-index: 0;
  border: none;
  border-radius: 0.5rem;
  position: relative;
}

.fs-title {
  font-size: 25px;
  color: #2c3e50;
  margin-bottom: 10px;
  font-weight: bold;
  text-align: left;
}

#progressbar {
  margin-bottom: 30px;
  overflow: hidden;
  color: lightgrey;
}

#progressbar .active {
  color: #000000;
}

#progressbar li {
  list-style-type: none;
  font-size: 12px;
  width: 9.5%;
  text-align:center;
  float: left;
  position: relative;
}

#progressbar #NewTraining:before {
  content: "1";
}

#progressbar #PoAssignment:before {
  content: "2";
}

#progressbar #TrainingInformation:before {
  content: "3";
}

#progressbar #TrainingAgenda:before {
  content: "4b";
}
#progressbar #Trainingmaterial:before {
  content: "4c";
}

#progressbar #TrainingAssessments:before {
  content: "4d";
}

#progressbar #TrainerRegistration:before {
  content: "4a";
}

#progressbar #TraineeRegistration:before {
  content: "4e";
}

#progressbar #AssessmentReview:before {
  content: "5";
}

#progressbar #Completion:before {
  content: "6";
}
#progressbar li:before {
  width: 35px;
  height: 35px;
  line-height: 30px;
  display: block;
  font-size: 18px;
  color: #ffffff;
  background: lightgray;
  border-radius: 50%;
  margin: 0 auto 10px auto;
  padding: 2px;
}

#progressbar li:after {
  content: "";
  width: 100%;
  height: 2px;
  background: lightgray;
  position: absolute;
  left: 0;
  top: 17px;
  z-index: -1;
}

#progressbar li.active:before,
#progressbar li.active:after {
  background: #000000;
}

.radio-group {
  position: relative;
  margin-bottom: 25px;
}

.radio {
  display: inline-block;
  width: 204;
  height: 104;
  border-radius: 0;
  background: lightblue;
  box-shadow: 0 2px 2px 2px rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
  cursor: pointer;
  margin: 8px 2px;
}

.radio:hover {
  box-shadow: 2px 2px 2px 2px rgba(0, 0, 0, 0.3);
}

.radio.selected {
  box-shadow: 1px 1px 2px 2px rgba(0, 0, 0, 0.1);
}

.fit-image {
  width: 100%;
  object-fit: cover;
}

/*Sheet style */
  table {
            width: 100%;
            border-collapse: collapse;
        }
        th, td, tr {
            border: 1px solid black;
            padding: 8px;
            text-align: center;
        }
        th {
            background-color: #f2f2f2;
        }
        .header {
            /* display: flex; */
            justify-content: space-between;
            align-items: center;

        }

        h2 {
            text-align: center;
            text-decoration: underline;
        }
        .address {
            font-size: 14px;
            margin-top: 0px;
            text-align: left;
        }
        .list_name{
          font-size: 18px
        }

       #attendance-sheet {
  display: none;
}

/* Only show the attendance sheet when printing */
@media print {
  #attendance-sheet {
    display: block;
    position: relative;
    width: 100%;
    page-break-before: always; /* Ensure the sheet starts on a new page */
  }

  /* Hide everything else during printing */
  body * {
    visibility: hidden;
  }

  #attendance-sheet, #attendance-sheet * {
    visibility: visible;
  }

  #attendance-sheet {
    position: absolute;
    top: 0;
    left: 0;
  }
}
</style>
